import { createAction } from "@reduxjs/toolkit";

export const updateProfileData = createAction("UPDATE_PROFILE_DATA");
export const resetProfileData = createAction("RESET_PROFILE_DATA");
